module.exports = __webpack_public_path__ + "static/img/motorbike-orange.f786e88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/motorbike-orange.svg
// module id = RTex
// module chunks = 74